export const AUTH_AUTO_LOGIN = 'AUTH_AUTO_LOGIN';
export const AUTH_FAILED = 'AUTH_FAILED';
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGIN_FROM_RESET = 'AUTH_LOGIN_FROM_RESET';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_CLEAR_ERROR = 'AUTH_CLEAR_ERROR';
export const AUTH_REPLACE_TOKEN = 'AUTH_REPLACE_TOKEN';
